export class ErrorMessage {
  constructor(error, message, code) {
    this.error = error; //name identifier of the error
    this.message = message ? message : this.getMessage(error); //message to show can be empty
    this.statusCode = new String(code); // code refence, optional
  }
  getMessage(error) {
    if(error&&error.data ){
      return error.data
    }
    return "error "+error+" encountered";
  }
}
